import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DashboardComponent from '../components/dashboardComponent';
import { loggedIn, logout, logOutAdmin } from '../../SuperAdminLogin/actions/superAdminLoginAction'

class DashboardContainer extends Component {
   

    componentWillMount() {
        
            // if (loggedIn(this.props.login.authTokenId)) {

            // }
            // else {
            //     logout()
            //     this.props.actions.logOutAdmin();
            //     this.props.history.push('/adminLogin');
            // }
        
       
    }

    render() {
        return (
            
                    <DashboardComponent />
                
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            logOutAdmin
        }, dispatch)
    };
};

function mapStateToProps({ superAdminLoginReducer }) {
    return {
        login: {
            authTokenId: superAdminLoginReducer.authTokenId,
            adminId: superAdminLoginReducer.adminId
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardContainer))